import ReduxStore from '../../../ReduxStore';

export const storedComparableItems = (sectionName) => {
  const {comparableSales, comparableRentals, comparableListings} = ReduxStore.getState();

  if (sectionName === 'COMPARABLE_SALES') {
    return comparableSales;
  } else if (sectionName === 'COMPARABLE_LISTINGS') {
    return comparableListings;
  } else if (sectionName === 'COMPARABLE_RENTALS') {
    return comparableRentals;
  }
};